import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";
import { getAnalytics } from "firebase/analytics";
import {
  firebaseConfig,
  FIREBASE_CONFIG,
  VAPID_KEY,
  vapidKey,
} from "../../openbrix-design-system/utils/firebaseConfig";

export { firebaseConfig, FIREBASE_CONFIG, VAPID_KEY, vapidKey };

export const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);
export const analytics = getAnalytics(app);